// Shared column sizing for the bulk and Google Sheet request grids.
const WIDTHS = {
  script: "min-w-[300px]",
  comments: "min-w-[220px]",
  topic: "min-w-[200px]",
  script_name: "min-w-[200px]",
  reference_link: "min-w-[200px]",
  module: "min-w-[200px]",
  creative_format: "min-w-[200px]",
  visual_format: "min-w-[200px]",
  track: "min-w-[180px]",
  category: "min-w-[160px]",
  account: "min-w-[160px]",
  requester_name: "min-w-[150px]",
  ad_type: "min-w-[150px]",
  track_number: "min-w-[90px]",
  hooks_count: "min-w-[100px]",
};

/** Minimum width per column so values are not squeezed to the header's width. */
export const columnWidth = (key) =>
  WIDTHS[key] ??
  (/^hook_\d+_link$/.test(key) ? "min-w-[260px]" : "min-w-[140px]");

// The ad set name stays pinned on the right while the grid scrolls sideways.
export const STICKY_ADSET_HEAD =
  "sticky right-0 z-20 w-[300px] min-w-[300px] bg-white shadow-[-6px_0_8px_-6px_rgba(0,0,0,0.18)]";
export const STICKY_ADSET_CELL =
  "sticky right-0 z-[1] w-[300px] min-w-[300px] bg-white shadow-[-6px_0_8px_-6px_rgba(0,0,0,0.18)]";
